import axios, {
  type AxiosInstance,
} from 'axios';
import type { PopupRequest } from '@azure/msal-browser';

import {
  API_URL,
  HUB_API_URL,
  INVENTORY_API_URL,
  MSAL_CLIENT_ID,
  PROXY_API_BASE_URL,
  AI_ANALYZER_API_URL,
} from '@/config/env';
import { conformanceRequest, hubRequest, inventoryRequest } from '@/config/msalConfig';
import { getToken, triggerReauthentication } from './utils';

const attachAuthInterceptors = (api: AxiosInstance, request: PopupRequest) => {
  api.interceptors.request.use(async (config) => {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${await getToken(request)}`;
    return config;
  });

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error?.response?.status === 401) {
        try {
          await triggerReauthentication(request);
        } catch (reauthenticationError) {
          console.error(reauthenticationError);
        }
      }

      return Promise.reject(error);
    },
  );
};

export const inventoryApi = axios.create({
  baseURL: INVENTORY_API_URL,
});

attachAuthInterceptors(inventoryApi, inventoryRequest);

export const conformanceApi = axios.create({
  baseURL: API_URL,
});

attachAuthInterceptors(conformanceApi, conformanceRequest);

export const hubApi = axios.create({
  baseURL: HUB_API_URL,
});

attachAuthInterceptors(hubApi, hubRequest);

export const aiAnalyzerApi = axios.create({
  baseURL: AI_ANALYZER_API_URL,
});

export const proxyApi = axios.create({
  baseURL: PROXY_API_BASE_URL,
});

const proxyRequest = {
  scopes: [`api://${MSAL_CLIENT_ID}/user_impersonation`],
};

attachAuthInterceptors(proxyApi, proxyRequest);
